var React = require('react');

function Location (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ICONS_nieuwwwwww"),React.createElement("path",{"d":"M29.44,0A29.48,29.48,0,0,0,0,29.44C0,41.62,15.38,65.23,24.55,78.23a6,6,0,0,0,9.77,0c9.17-13,24.56-36.6,24.56-48.78A29.48,29.48,0,0,0,29.44,0Zm0,74.33c-11.26-16-23.2-36.09-23.2-44.89a23.2,23.2,0,0,1,46.4,0C52.64,38.24,40.7,58.34,29.44,74.33Z","fill":"#2a2d58","key":1}),React.createElement("path",{"d":"M29.44,18.2A12.81,12.81,0,1,0,42.24,31,12.82,12.82,0,0,0,29.44,18.2Zm0,19.37A6.57,6.57,0,1,1,36,31,6.57,6.57,0,0,1,29.44,37.57Z","fill":"#f1b860","key":2})]);
}

Location.defaultProps = {"viewBox":"0 0 58.88 80.76"};

module.exports = Location;

Location.default = Location;
